export class ActivitySaveResult {
  ActivityValue: number | null = null;
  BonusValue: number | null = null;
  GatheredBadge: string | null = null;
  GatheredUserLevel: number | null = null;
  IsCorrect: boolean | null = null;
  constructor(data: any) {
    if (data != null) {
      this.ActivityValue = data.activityValue;
      this.BonusValue = data.bonusValue;
      this.GatheredBadge = data.gatheredBadge;
      this.GatheredUserLevel = data.gatheredUserLevel;
      this.IsCorrect = data.isCorrect;
    }
  }
}
